<template>
  <div
    class="base-tooltip"
  >
    <el-tooltip
      v-bind="!allowHtml ? { content: tooltipText } : {}"
      :disabled="!tooltipText"
      :placement="placement"
      :effect="color"
      :open-delay="openDelay"
    >
      <template #content>
        <div
          v-if="allowHtml"
          v-html="tooltipText"
          :style="tooltipStyle"
        ></div>
        <div
          v-else
          :style="tooltipStyle"
        >
          {{ tooltipText }}
        </div>
      </template>
      <slot>
        <div class="base-tooltip__trigger"></div>
      </slot>
    </el-tooltip>
  </div>
</template>

<script>

export default {
  name: 'BaseTooltip',
  props: {
    tooltipText: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'dark',
    },
    placement: {
      type: String,
      default: 'bottom-end',
    },
    allowHtml: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: 261,
    },
    /**
     * Delay (ms) before the tooltip pops up after the pointer enters the
     * trigger. Useful for dense grids where quick mouse sweeps shouldn't
     * stack up a flurry of tooltips. Maps directly to el-tooltip's
     * `open-delay` prop. Defaults to 0 to preserve existing behavior at
     * every other usage site.
     */
    openDelay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tooltipStyle() {
      return {
        maxWidth: typeof this.width === 'number' ? `${this.width}px` : this.width,
      };
    },
  },
};
</script>

<style lang="scss">
.base-tooltip__trigger {
  width: 16px;
  height: 16px;
  background-image: url(/public/img/renova-dashboard/icons/help-circle.svg);
  cursor: pointer;
}

.el-tooltip__popper {
  ul {
    margin: 8px 0 0;
    padding: 0 0 0 20px;

    li {
      padding: 0;
    }
  }
}

.el-tooltip__popper.is-dark {
  color: #FFF;
  border-radius: 8px;
  background: var(--solid-black-purple-09) !important;
  transform: translateX(5px);
  transition: .3s;
  padding: 12px 16px;
  max-width: fit-content;
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  z-index: 50000 !important;

  .popper__arrow {
    border-bottom-color: var(--solid-black-purple) !important;
    opacity: 0.9;

    &::after {
      border-bottom-color: var(--solid-black-purple) !important;
      opacity: 0.9;
    }
  }
}

.el-tooltip__popper.is-light {
  color: var(--solid-black-purple);
  border-radius: 8px;
  background: #FFF !important;
  transform: translateX(5px);
  transition: .3s;
  padding: 12px 16px;
  max-width: fit-content;
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border: 1px solid var(--solid-lavender-grey) !important;
  z-index: 5000 !important;
  box-shadow: 0px 2px 8px 0px rgba(24, 7, 38, 0.15);

  .popper__arrow {
    border-bottom-color: #FFF !important;

    &::after {
      border-bottom-color: #FFF !important;
    }
  }
}

</style>
